import moment from "moment";
import { bodyWeightFormat } from "../body-composition.helper";

const CalendarPicker = ({ startDate, endDate, onClick }) => (
  <div className="composition-calendar-picker" onClick={onClick}>
    <PickedData startDate={startDate} endDate={endDate} />
  </div>
);

const PickedData = ({ startDate }) => (
  <a className="calendar-picker-select">
    {moment(startDate).format("MMMM, YYYY")}
    <img
      src="/img/svg/green-angle-down.svg"
      style={{
        width: "11px",
        height: "6px",
        marginLeft: 16,
      }}
    />
  </a>
);

export default CalendarPicker;
